<template>
  <div class="mars-ape-layout-header">
    <div class="header-left">
      <i class="iconfont header-index-trigger"  v-if="mxIsContract == 1" :class="[isCollapse?'icon-menu-fold':'icon-menu-unfold']" @click="handleClick"></i>
      <div class="header-index-trigger" style="padding-left:12px;padding-right:12px;" v-else></div>
    </div>
    <!-- <div class="header-middle">
      <el-row :gutter="20">
        <div class="content-label">
          当前商户：
        </div>
        <el-col :span="8" class="content-left">
          <el-select v-model="companyId" placeholder="请选择公司" @change="companyChange">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <div class="content-label">
          服务公司：
        </div>
        <el-col :span="8" class="content-left">
          <el-select v-model="settlementId" placeholder="请选择服务公司" @change="settlementChange">
            <el-option
              v-for="item in settlementList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" class="content-left btn-swtich">
          <el-button type="primary" icon="el-icon-refresh-left" size="medium" @click="onSubmit()">切换公司</el-button>
        </el-col>
      </el-row>
    </div> -->
    <div class="header-right">
      <!-- <el-button type="text" class="info" @click="gotoAnnounce">
        <el-badge :value=" (this.localStroageId != this.id) ? 1 : null" class="item">
          <i class="el-icon-message-solid" style="font-size: 20px" :id="(this.localStroageId != this.id) ? 'has-message' : 'nohas-message'"></i>
        </el-badge>
      </el-button> -->
      <span class="right-notice" @click="gotoWarningList" v-show="warn_show">
        <el-badge :value="warn_num==0?'':warn_num" class="item">
          <i class="iconfont icon-lingdang"></i>
        </el-badge>
      </span>
      <el-dropdown @command="handleCommand">
        <span class="right-account">
          <span class="right-account-avatar">
            <img src="@/assets/avatar.png" alt="avatar">
          </span>
          <span class="right-account-name">{{userInfo['fullname']}}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="setting"><i class="iconfont icon-touxiang"></i><span>个人设置</span></el-dropdown-item> -->
          <el-dropdown-item command="setting"><i class="iconfont icon-touxiang"></i><span>个人设置</span></el-dropdown-item>
          <el-dropdown-item divided command="logout"><i class="iconfont icon-tuichudenglu2"></i><span>退出登录</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      form: {
        companyId: '',
        settlementId: '',
      },
      localStroageId: '',
      warn_num: 0 ,
      id: '',
      warn_show: false
    }
  },
  inject: ['reload'],
  computed: {
    ...mapState({
      companyList: state => state.switchInfo.companyList,
      settlementList: state => state.switchInfo.settlementList,
    }),
    ...mapGetters({
      isCollapse: 'isCollapse',
      userInfo: 'userInfo',
    }),
    companyId: {
      get() {
        return this.mxCompanyId
      },
      set (value) {
        this.$store.commit('changeSwitchInfo', { key: 'companyId', value: value })
      },
    },
    settlementId: {
      get() {
        return this.mxSettlementId
      },
      set (value) {
        this.$store.commit('changeSwitchInfo', { key: 'settlementId', value: value })
      },
    },
  },
  watch: {
    "companyId": function(v) {
      let companyIds = this.$config.domain.settlmentlCustom.companyIds
      let newSettlementList = Object.assign(this.settlementList, [])
      companyIds.forEach(item => {
        if(item == v) {
          newSettlementList.forEach(i => {
            if(i.name == this.$config.domain.settlmentlCustom.originName) {
              i.name = this.$config.domain.settlmentlCustom.currentName
            }
          })
          this.$store.commit('changeSwitchInfo', { key: 'settlementList', value: newSettlementList })
        }
      })
    }
  },
  methods: {
    ...mapMutations([
      'handleUserInfo'
    ]),
    // async getInfo() {
    //   let data = await this.$api.getPrice()
    //   this.id = data.announcement.id
    // },
    //查看公告消息
    async gotoAnnounce() {
      // if( this.id ) {
      //   this.$router.push('/notice')
      // }
      this.$router.push('/notice')
    },
	// 查看警告数量
	async gotoWarningList(){
		this.$router.push('/warning_list');
	},
    // 左侧菜单的展开折叠
    handleClick () {
      this.$store.commit('changeCollapse')
    },
    // 处理下拉菜单指令
    handleCommand(command) {
      if (command === 'setting') {
        this.$router.push('/bindaccount')
      }
      if (command === 'logout') {
        this.handleLogout()
      }
    },
    // 处理退出
    async handleLogout() {
        this.$api.submitLogout()
        localStorage.removeItem('user_info')
        // this.$storage.remove('accountment_id')
        this.$message.success('退出成功！')
        this.$router.push('/login')
    },
    // 公司选择
    async companyChange(v) {
      if (v) {
        this.$store.commit('changeSwitchInfo', { key: 'companyId', value: v })
        let args = { company_id: v }
        const settlementList = await this.$api.getUserSettlement(args)
        let companyIds = this.$config.domain.settlmentlCustom.companyIds
        let newSettlementList = Object.assign(settlementList, [])
        companyIds.forEach(item => {
          if(v == item) {
            newSettlementList.forEach((i) => {
              if(i.name == this.$config.domain.settlmentlCustom.originName) {
                i.name = this.$config.domain.settlmentlCustom.currentName
              }
            })
            this.$store.commit('changeSwitchInfo', { key: 'settlementList', value: newSettlementList })
          }
        })
        this.$store.commit('changeSwitchInfo', { key: 'settlementList', value: settlementList })
        this.$store.commit('changeSwitchInfo', { key: 'settlementId', value: settlementList[0].id })
      }
    },
    // 服务公司选择
    async settlementChange(v) {
      if (v) {
        console.log(v,"settlementChange=>vvv")
        this.$store.commit('changeSwitchInfo', { key: 'settlementId', value: v })
      }
    },
    // 按钮提交
    async onSubmit() {
      let info = await this.$api.userSwitch(this.companyId, this.settlementId)
      console.log("info", info)
      if (info) {
        this.mxInitUserInfo()
        if (this.$route.path === '/') {
          this.reload()
        } else {
          this.mxRedirect('/')
        }
        // localStorage.setItem("XL_COMPANY_ID", this.companyId)
        // localStorage.setItem("XL_SETTLEMENT_ID", this.settlementId)
        // this.$notify({
        //   title: 'SYSTEM',
        //   message: '公司切换成功',
        //   type: 'success',
        //   duration: 3000
        // })
        // this.reload()
        this.$message({
          message: '切换成功',
          type: 'success',
          duration: '500'
        })
      }
    },
	async getWarnNum() {
		// let tenant_id = JSON.parse(this.$storage.get('user_info')).tenant_id;
		// this.$config.domain.ename === 'yousuiyun'
		if(this.$config.domain.ename === 'opryousuiyun') {
			this.warn_show = true;
			let {pages} = await this.$api.getWarnNum()
			this.warn_num = pages.total
		}
	}
  },
  created() {
  },
  mounted() {
    // this.getInfo()
    this.localStroageId = this.$storage.get("accountment_id")
	// this.getWarnNum();
  },
}
</script>

<style lang="stylus" scoped>
.content-label
  float left
  margin-right 3px
  margin-left 10px
.mars-ape-layout-header .iconfont
  display inline-block
  box-sizing border-box
  font-size 24px
.mars-ape-layout-header
  height 64px
  background #fff
  box-shadow 0 1px 4px rgba(0,21,41,.08)
  position relative
  overflow hidden
.mars-ape-layout-header>.header-left,.mars-ape-layout-header>.header-middle
  float left
  color #595959
.mars-ape-layout-header>.header-middle
  line-height 64px
.mars-ape-layout-header>.header-right
  float right
  line-height 64px
  overflow hidden
.mars-ape-layout-header>.header-left>.header-index-trigger
  font-size 9pt
  height 64px
  cursor pointer
  transition all .3s,padding 0s
  padding 22px 24px
i.header-index-trigger:hover
  background rgba(0,0,0,.025)
.header-right .right-account,.header-right .right-notice
  padding 0 12px
  display inline-block
  transition all .3s
  cursor pointer
  color:rgba(0,0,0,.65)
.right-notice .el-badge
  line-height 24px
.right-account-avatar>img
  width 100%
  display block
.right-account-avatar
  width 24px
  line-height 24px
  border-radius 50%
  display inline-block
  margin 20px 8px 20px 0
  vertical-align top
.right-account-name
  font-size 14px
.right-notice:hover,.right-account:hover
  background rgba(0,0,0,.025)
.el-dropdown-menu__item
  padding 5px 12px
  line-height 22px
  font-weight 400
  color rgba(0,0,0,0.65)
.el-dropdown-menu__item > .iconfont
  margin-right 8px
.el-dropdown-menu
  padding 4px 0
  margin 0px
.el-dropdown-menu__item--divided
  padding-top 0px
  line-height 28px
.el-dropdown-menu__item--divided::before
  margin 0 -12px
.el-dropdown-menu.el-popper
  min-width 160px
  top 56px !important
.el-popper .popper__arrow
  border-width 0px
.el-popper .popper__arrow::after
  border-width 0px
.el-select
  width 280px
.btn-swtich
  margin-left 15px
.info
  margin-right: 10px
  height: 100%
#has-message
  color: #f56c6c
#nohas-message
  color: #909399
</style>
